import { forwardRef } from "react";
import { motion } from "motion/react"
import className from "classnames/bind";
import { MaterialLoader } from "@components";

import styles from "./Search.module.scss";
const cx = className.bind(styles);


const SearchLoader = forwardRef<HTMLDivElement, { className?: string }>((props, ref) => {
  const { className } = props;
  return (
    <div className={cx(["search-container__results-loading", className])} ref={ref}>
      <MaterialLoader className={cx("spinner")} />
    </div>
  )
});

export default motion.create(SearchLoader);